export enum TicketStages{
    beta,
    revision,
    qa,
    complete
}